import { Link } from "react-router-dom";
import { allCategories } from "@/lib/video";

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer id="site-footer" className="mt-16 bg-primary-950 text-background-100">
      <div className="mx-auto w-full max-w-[1440px] px-4 py-12 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-play-fill text-xl" />
              </span>
              <span className="font-heading text-lg font-bold text-background-50">
                逼特逼视频
              </span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-background-300">
              多样视频内容聚合平台，涵盖影视剪辑、短视频与用户原创作品，帮你快速发现感兴趣的内容。
            </p>
            <div className="mt-5 flex items-center gap-3">
              <span className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md bg-background-50/10 text-background-100 transition-colors hover:bg-accent-500 hover:text-primary-950">
                <i className="ri-weibo-fill text-lg" />
              </span>
              <span className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md bg-background-50/10 text-background-100 transition-colors hover:bg-accent-500 hover:text-primary-950">
                <i className="ri-wechat-fill text-lg" />
              </span>
              <span className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md bg-background-50/10 text-background-100 transition-colors hover:bg-accent-500 hover:text-primary-950">
                <i className="ri-bilibili-fill text-lg" />
              </span>
              <span className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md bg-background-50/10 text-background-100 transition-colors hover:bg-accent-500 hover:text-primary-950">
                <i className="ri-mail-line text-lg" />
              </span>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50">
              <a href="#site-footer" className="hover:text-accent-400">
                快速导航
              </a>
            </h4>
            <ul className="mt-4 flex flex-col gap-2.5 text-sm">
              <li>
                <Link to="/" className="cursor-pointer text-background-300 transition-colors hover:text-accent-400">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/search" className="cursor-pointer text-background-300 transition-colors hover:text-accent-400">
                  视频搜索
                </Link>
              </li>
              <li>
                <Link to="/contact" className="cursor-pointer text-background-300 transition-colors hover:text-accent-400">
                  联系我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50">
              <a href="#site-footer" className="hover:text-accent-400">
                热门分类
              </a>
            </h4>
            <ul className="mt-4 grid grid-cols-2 gap-2.5 text-sm lg:grid-cols-1">
              {allCategories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="cursor-pointer text-background-300 transition-colors hover:text-accent-400"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50">
              <a href="#site-footer" className="hover:text-accent-400">
                关于本站
              </a>
            </h4>
            <p className="mt-4 text-sm leading-relaxed text-background-300">
              本站为演示性质的视频聚合站点，站内所有视频、图片与文字内容均为示例数据，不代表任何真实来源。
            </p>
            <p className="mt-3 text-sm text-background-300">
              如需反馈或合作，欢迎通过「联系我们」页面留言。
            </p>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-start justify-between gap-3 border-t border-background-50/15 pt-6 text-xs text-background-400 sm:flex-row sm:items-center">
          <p>© {year} 逼特逼视频 版权所有 · 本站内容为演示数据</p>
          <div className="flex flex-wrap items-center gap-4">
            <span className="cursor-pointer transition-colors hover:text-accent-400">隐私条款</span>
            <span className="cursor-pointer transition-colors hover:text-accent-400">服务条款</span>
            <span className="cursor-pointer transition-colors hover:text-accent-400">版权声明</span>
          </div>
        </div>
      </div>
    </footer>
  );
}